import { useState, useEffect } from 'react';
import axios from 'axios';
import { Layers, Users } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/atendimento`;
const headers = () => ({Authorization: `Bearer ${localStorage.getItem('recupnet_token')}`});

const OP_STATUS = {online:{label:'Online',badge:'badge-success'},busy:{label:'Ocupado',badge:'badge-warning'},break:{label:'Pausa',badge:'badge-neutral'},offline:{label:'Offline',badge:'badge-danger'}};

export default function AtendimentoQueues() {
  const [queues, setQueues] = useState([]);
  const [ops, setOps] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      axios.get(`${API}/queues`, {headers: headers()}).then(r => setQueues(r.data)),
      axios.get(`${API}/operators`, {headers: headers()}).then(r => setOps(r.data)),
    ]).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex justify-center py-20"><div className="rn-spinner" style={{width:28,height:28}}/></div>;

  return (
    <div className="p-6 space-y-6">
      <h1 className="font-display text-2xl font-semibold">Filas e Operadores</h1>

      <div>
        <h2 className="text-xs text-white/40 uppercase tracking-wider font-semibold mb-3">Filas</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
          {queues.map(q => (
            <div key={q.id} className="glass-card">
              <div className="flex items-center gap-2 mb-2"><Layers size={16} style={{color:'var(--rn-green)'}}/><h3 className="text-sm font-semibold">{q.name}</h3></div>
              <p className="text-[10px] text-white/35 mb-2">{q.description}</p>
              <div className="flex gap-2">
                <span className="badge-warning text-[9px]">{q.waitingCount} aguardando</span>
                <span className="badge-success text-[9px]">{q.activeCount} ativos</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div>
        <h2 className="text-xs text-white/40 uppercase tracking-wider font-semibold mb-3">Operadores</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {ops.map(o => {
            const st = OP_STATUS[o.status] || OP_STATUS.offline;
            return (
              <div key={o.id} className="glass-card">
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2"><Users size={16} className="text-white/40"/><h3 className="text-sm font-semibold">{o.name}</h3></div>
                  <span className={`${st.badge} text-[9px]`}>{st.label}</span>
                </div>
                <p className="text-[10px] text-white/35">{o.email}</p>
                <p className="text-[10px] text-white/35">Atendimentos: {o.activeConversations || 0}/{o.maxConcurrent}</p>
                <p className="text-[10px] text-white/35">Perfil: {o.role}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
